var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.facility.displayId)?_c('EmergencyOverview',{attrs:{"elevator-id":_vm.facility.displayId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }